import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostStandortCommandServiceModule } from '..';
import { PostStandortCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostStandortCommandServiceModule
  ],
  declarations: [PostStandortCommandComponent],
  exports: [PostStandortCommandComponent],

})
export class PostStandortCommandComponentModule { }
